module.exports = __webpack_public_path__ + "img/hp-h3.f23cb2ee.svg";